import { z } from 'zod'

export const SignUpInput = z.object({
	email: z.string().transform((email) => email.toLowerCase()), //.email(),
	password: z.string().min(6),
	joinNewsletter: z.boolean().optional().nullable(),
	eBookVariant: z.string().optional().nullable(),
})

export type SignUpInput = z.infer<typeof SignUpInput>
